/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_PausedInputs */

const vi_grower_area_camera_paused = /** @type {(inputs: Grower_Area_Camera_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạm ngắt khi đang xem chi tiết camera`)
};

/**

* @param {Grower_Area_Camera_PausedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_paused = /** @type {((inputs?: Grower_Area_Camera_PausedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_PausedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_paused(inputs)
});